import { sortCurriculumTypesWithKFirst } from 'experienceComponents/CreateInstanceShared/dataUtils'
import {
  filterSmallGroupCurriculumTypes,
  convertGradeToDisplayValue,
  getRelevantCourseListForSmallGroup,
  convertGradeNameToLabel,
  getProgramName,
  createViewClassBehavior,
} from './data'

// Filter and sort configuration
export const smallGroupFilterConfig = {
  filterFunction: filterSmallGroupCurriculumTypes,
  sortFunction: sortCurriculumTypesWithKFirst,
  getRelevantCourseList: getRelevantCourseListForSmallGroup,
  convertGradeToDisplayValue: convertGradeToDisplayValue,
}

// Program mapping configuration
export const smallGroupProgramConfig = {
  convertGradeNameToLabel: convertGradeNameToLabel,
  getProgramName: getProgramName,
}

// View class behavior configuration
export const smallGroupViewClassConfig = {
  createViewClassBehavior: createViewClassBehavior,
}

// Small group configuration
export const SMALL_GROUP_CONFIG = {
  schemaName: 'CREATESMALLGROUPSCHEMA',
  requiresLicense: false,
  requiresDates: false,
  filterFunction: 'filterSmallGroupCurriculumTypes',
  sortFunction: 'sortCurriculumTypesWithKFirst',
  getRelevantCourseList: getRelevantCourseListForSmallGroup,
  duplicateMessage: 'You may not have a duplicate small group name',
  validatorClass: 'CreateSmallGroupValidator',
  validationType: 'smallGroup',
}

// Legacy config for backward compatibility
export const smallGroupConfig = {
  ...smallGroupFilterConfig,
  ...smallGroupProgramConfig,
  ...smallGroupViewClassConfig,
}
